import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authSuccessAction } from '../../../state/actions/creators/auth.actioncreator';

/* eslint func-names: 0 */
/* eslint default-case: 0 */
/* eslint react/prop-types: 0 */
/* eslint no-case-declarations: 0 */
/* eslint no-shadow: 0 */

class MessageReceiver extends React.Component {
  constructor(props) {
    super(props);
    const { history, authSuccessAction } = this.props;

    window.onmessage = function (e) {
      const { data } = e;
      if (data) {
        try {
          const message = JSON.parse(data);
          const { action, data: messageData } = message;

          switch (action) {
            case 'route':
              const { url } = messageData;
              history.replace(url);
              break;
            case 'auth':
              const { auth } = messageData;
              const { token, user } = auth;
              authSuccessAction(token, user, null);
              break;
          }
        } catch (exception) {}
      }
    };
  }

  render() {
    return <div />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ authSuccessAction }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps,
)(withRouter(MessageReceiver));
